import type { Reducer } from 'redux';
import {
    FETCH_DEALERSHIPS_REQUEST,
    FETCH_DEALERSHIPS_SUCCESS,
    FETCH_DEALERSHIPS_FAILURE
} from '../actionTypes/dealershipsActionTypes';

export interface Dealership {
    dealerMMDId: number;
    name: string;
    commonOrgId: string;
    dealerName?: string;
    dnaAccountId?: string;
    ownerId?: number;
}

export interface DealershipsState {
    dealerships: Dealership[];
    loading: boolean;
    error: string | null;
}

export type DealershipsReducer = Reducer<DealershipsState>;

const initialState: DealershipsState = {
    dealerships: [],
    loading: false,
    error: null
};

export const reducer: DealershipsReducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case FETCH_DEALERSHIPS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_DEALERSHIPS_SUCCESS:
            return {
                ...state,
                dealerships: payload?.dealerships || [],
                loading: false,
                error: null
            };
        case FETCH_DEALERSHIPS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload?.message || 'Failed to fetch dealerships'
            };
        default:
            return state;
    }
};
